export const keys = {
  showRedeemCode: process.env.REACT_APP_COMPETITIONGOLF_SHOW_REDEEM_CODE,
  hidePublicPages: process.env.REACT_APP_HIDE_PUBLIC_PAGES,
  showMembers: process.env.REACT_APP_COMPETITIONGOLF_SHOW_MEMBERS,
  showMatchplay: process.env.REACT_APP_COMPETITIONGOLF_SHOW_MATCHPLAY,
  showEvents: process.env.REACT_APP_COMPETITIONGOLF_SHOW_EVENTS,
  showTopMenu: process.env.REACT_APP_COMPETITIONGOLF_SHOW_TOP_MENU,
  showDashboard: process.env.REACT_APP_COMPETITIONGOLF_SHOW_DASHBOARD,
  showGroups: process.env.REACT_APP_COMPETITIONGOLF_SHOW_GROUPS
};

export const getBooleanSettingValue = (value) => {
  return (value && !value.startsWith('#{') && !value.endsWith('}#')) ? JSON.parse(value) : false;
};
